module.exports = __webpack_public_path__ + "img/astro-camera.edebc97a.svg";